<template>
  <div class="datepicker-years">
    <table class="table-condensed">
      <thead>
        <tr>
          <th class="prev" @click.prevent="previous">
            <span class="glyphicon glyphicon-chevron-left" title="Previous Decade"></span>
          </th>
          <th class="picker-switch" colspan="5" title="Select Decade">
            {{ `${startYear}-${endYear}` }}
          </th>
          <th class="next" @click.prevent="next">
            <span class="glyphicon glyphicon-chevron-right" title="Next Decade"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="7">
            <span
              v-for="i in endYear - startYear + 1"
              :key="i"
              @click="selectYear(parseInt(startYear) + (i - 1))"
              class="year"
              :class="[activeYearClass(parseInt(startYear) + (i - 1))]"
            >
              {{ parseInt(startYear) + (i - 1) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'YearPicker',
  props: {
    currentDate: {
      default: () => moment()
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY'
    }
  },
  data() {
    return {
      startYear: moment(this.currentDate)
        .add(-7, 'years')
        .format('YYYY'),
      endYear: moment(this.currentDate)
        .add(7, 'years')
        .format('YYYY')
    }
  },
  computed: {
    activeYearClass: vm => selectedYear => {
      return {
        active: selectedYear.toString() === vm.currentDate.format('YYYY')
      }
    }
  },
  methods: {
    previous() {
      this.startYear = parseInt(this.startYear) - 15
      this.endYear = parseInt(this.endYear) - 15
    },
    next() {
      this.startYear = parseInt(this.startYear) + 15
      this.endYear = parseInt(this.endYear) + 15
    },
    selectYear(selectedYear) {
      this.$emit('select-year', selectedYear.toString())
      this.$emit('change-picker', 'month')
    }
  },
  watch: {
    currentDate: {
      handler(currentDate) {
        this.startYear = moment(this.currentDate)
          .add(-7, 'years')
          .format('YYYY')
        this.endYear = moment(this.currentDate)
          .add(7, 'years')
          .format('YYYY')
      },
      deep: true
    }
  }
}
</script>
